var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-moduleimage',{attrs:{"data":_vm.getId,"tag":'div',"custom-class":'module-background' + (this.customClass ? ' ' + this.customClass : '')}})}
var staticRenderFns = []

export { render, staticRenderFns }